import { render, staticRenderFns } from "./InfoUserEvaluationView.vue?vue&type=template&id=67756a95&"
import script from "./InfoUserEvaluationView.vue?vue&type=script&lang=js&"
export * from "./InfoUserEvaluationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports